import { DatePicker } from '@tkww/orion-web-ds-input';
import { TextBody } from '@tkww/orion-web-ds-text';
import React, { useState } from 'react';
import { getWeddingDateError } from '../../../utils/weddingDate';
import Styles from './styles.scss';

interface WeddingDateFieldProps {
	value: string;
	onChange: (value: string) => void;
}

export const WeddingDateField = ({
	value,
	onChange,
}: WeddingDateFieldProps) => {
	const [touched, setTouched] = useState(false);
	const error = touched
		? getWeddingDateError({
				dateOption: 'specificDate',
				specificDate: value,
				month: '',
				year: '',
			})
		: undefined;

	const handleDateChange: NonNullable<DatePicker.OwnProps['onChange']> = (
		e,
	) => {
		const { month: m, day, year: y } = e.detail.value;
		const isComplete = m && day && y && y.length === 4;
		setTouched(true);
		onChange(
			isComplete ? `${y}-${m.padStart(2, '0')}-${day.padStart(2, '0')}` : '',
		);
	};

	return (
		<div className={Styles.weddingDateField}>
			<hr className={Styles.divider} />
			<TextBody size="lg" bold className={Styles.title}>
				Wedding date
			</TextBody>
			<DatePicker
				label="Wedding date"
				name="weddingDate"
				value={
					value
						? {
								month: value.slice(5, 7),
								day: value.slice(8, 10),
								year: value.slice(0, 4),
							}
						: { month: '', day: '', year: '' }
				}
				onChange={handleDateChange}
				state={error ? 'invalid' : 'neutral'}
				subText={error}
				data-testid="wedding-date-input"
			/>
		</div>
	);
};
